export default {
  toolbarBtn: {
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: "5px 10px",
    boxShadow: "none",
  },
};